import { __decorate, __metadata, __param } from 'tslib';
import { EventEmitter, Optional, Host, SkipSelf, Input, Output, ViewChild, ElementRef, ViewContainerRef, ContentChild, TemplateRef, Component, NgModule } from '@angular/core';
import { AgmMarker, GoogleMapsAPIWrapper, MarkerManager, MapsAPILoader } from '@agm/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@agm/core';

const _c0 = ["outerWrapper"];
const _c1 = ["viewContainer"];
const _c2 = ["*"];
let AgmSnazzyInfoWindow = class AgmSnazzyInfoWindow {
    constructor(_marker, _wrapper, _manager, _loader) {
        this._marker = _marker;
        this._wrapper = _wrapper;
        this._manager = _manager;
        this._loader = _loader;
        /**
         * Changes the open status of the snazzy info window.
         */
        this.isOpen = false;
        /**
         * Emits when the open status changes.
         */
        this.isOpenChange = new EventEmitter();
        /**
         * Choose where you want the info window to be displayed, relative to the marker.
         */
        this.placement = 'top';
        /**
         * The max width in pixels of the info window.
         */
        this.maxWidth = 200;
        /**
         * The max height in pixels of the info window.
         */
        this.maxHeight = 200;
        /**
         * Determines if the info window will open when the marker is clicked.
         * An internal listener is added to the Google Maps click event which calls the open() method.
         */
        this.openOnMarkerClick = true;
        /**
         * Determines if the info window will close when the map is clicked. An internal listener is added to the Google Maps click event which calls the close() method.
         * This will not activate on the Google Maps drag event when the user is panning the map.
         */
        this.closeOnMapClick = true;
        /**
         * Determines if the info window will close when any other Snazzy Info Window is opened.
         */
        this.closeWhenOthersOpen = false;
        /**
         * Determines if the info window will show a close button.
         */
        this.showCloseButton = true;
        /**
         * Determines if the info window will be panned into view when opened.
         */
        this.panOnOpen = true;
        /**
         * Emits before the info window opens.
         */
        this.beforeOpen = new EventEmitter();
        /**
         * Emits before the info window closes.
         */
        this.afterClose = new EventEmitter();
        this._snazzyInfoWindowInitialized = null;
    }
    /**
     * @internal
     */
    ngOnChanges(changes) {
        if (this._nativeSnazzyInfoWindow == null) {
            return;
        }
        if ('isOpen' in changes && this.isOpen) {
            this._openInfoWindow();
        }
        else if ('isOpen' in changes && !this.isOpen) {
            this._closeInfoWindow();
        }
        if (('latitude' in changes || 'longitude' in changes) && this._marker == null) {
            this._updatePosition();
        }
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
        const m = this._manager != null ? this._manager.getNativeMarker(this._marker) : null;
        this._snazzyInfoWindowInitialized = this._loader.load()
            .then(() => require('snazzy-info-window'))
            .then((module) => Promise.all([module, m, this._wrapper.getNativeMap()]))
            .then((elems) => {
            const options = {
                map: elems[2],
                content: '',
                placement: this.placement,
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
                backgroundColor: this.backgroundColor,
                padding: this.padding,
                border: this.border,
                borderRadius: this.borderRadius,
                fontColor: this.fontColor,
                pointer: this.pointer,
                shadow: this.shadow,
                closeOnMapClick: this.closeOnMapClick,
                openOnMarkerClick: this.openOnMarkerClick,
                closeWhenOthersOpen: this.closeWhenOthersOpen,
                showCloseButton: this.showCloseButton,
                panOnOpen: this.panOnOpen,
                wrapperClass: this.wrapperClass,
                callbacks: {
                    beforeOpen: () => {
                        this._createViewContent();
                        this.beforeOpen.emit();
                    },
                    afterOpen: () => {
                        this.isOpenChange.emit(this.openStatus());
                    },
                    afterClose: () => {
                        this.afterClose.emit();
                        this.isOpenChange.emit(this.openStatus());
                    },
                },
            };
            if (elems[1] != null) {
                options.marker = elems[1];
            }
            else {
                options.position = {
                    lat: this.latitude,
                    lng: this.longitude,
                };
            }
            this._nativeSnazzyInfoWindow = new elems[0](options);
        });
        this._snazzyInfoWindowInitialized.then(() => {
            if (this.isOpen) {
                this._openInfoWindow();
            }
        });
    }
    _openInfoWindow() {
        this._snazzyInfoWindowInitialized.then(() => {
            this._createViewContent();
            this._nativeSnazzyInfoWindow.open();
        });
    }
    _closeInfoWindow() {
        this._snazzyInfoWindowInitialized.then(() => {
            this._nativeSnazzyInfoWindow.close();
        });
    }
    _createViewContent() {
        if (this._viewContainerRef.length === 1) {
            return;
        }
        const evr = this._viewContainerRef.createEmbeddedView(this._templateRef);
        this._nativeSnazzyInfoWindow.setContent(this._outerWrapper.nativeElement);
        // we have to run this in a separate cycle.
        setTimeout(() => {
            evr.detectChanges();
        });
    }
    _updatePosition() {
        this._nativeSnazzyInfoWindow.setPosition({
            lat: this.latitude,
            lng: this.longitude,
        });
    }
    /**
     * Returns true when the Snazzy Info Window is initialized and open.
     */
    openStatus() {
        return this._nativeSnazzyInfoWindow && this._nativeSnazzyInfoWindow.isOpen();
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        if (this._nativeSnazzyInfoWindow) {
            this._nativeSnazzyInfoWindow.destroy();
        }
    }
};
/** @nocollapse */
AgmSnazzyInfoWindow.ɵfac = function AgmSnazzyInfoWindow_Factory(t) { return new (t || AgmSnazzyInfoWindow)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AgmMarker, 13), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.GoogleMapsAPIWrapper), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MarkerManager), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MapsAPILoader)); };
/** @nocollapse */
AgmSnazzyInfoWindow.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AgmSnazzyInfoWindow, selectors: [["agm-snazzy-info-window"]], contentQueries: function AgmSnazzyInfoWindow_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._templateRef = _t.first);
    } }, viewQuery: function AgmSnazzyInfoWindow_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c1, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._outerWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._viewContainerRef = _t.first);
    } }, inputs: { isOpen: "isOpen", placement: "placement", maxWidth: "maxWidth", maxHeight: "maxHeight", openOnMarkerClick: "openOnMarkerClick", closeOnMapClick: "closeOnMapClick", closeWhenOthersOpen: "closeWhenOthersOpen", showCloseButton: "showCloseButton", panOnOpen: "panOnOpen", latitude: "latitude", longitude: "longitude", backgroundColor: "backgroundColor", padding: "padding", border: "border", borderRadius: "borderRadius", fontColor: "fontColor", fontSize: "fontSize", pointer: "pointer", shadow: "shadow", wrapperClass: "wrapperClass" }, outputs: { isOpenChange: "isOpenChange", beforeOpen: "beforeOpen", afterClose: "afterClose" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 5, vars: 0, consts: [["outerWrapper", ""], ["viewContainer", ""]], template: function AgmSnazzyInfoWindow_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵelement(2, "div", null, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(4);
    } }, encapsulation: 2 });
AgmSnazzyInfoWindow.ctorParameters = () => [
    { type: AgmMarker, decorators: [{ type: Optional }, { type: Host }, { type: SkipSelf }] },
    { type: GoogleMapsAPIWrapper },
    { type: MarkerManager },
    { type: MapsAPILoader }
];
__decorate([
    Input(),
    __metadata("design:type", Number)
], AgmSnazzyInfoWindow.prototype, "latitude", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], AgmSnazzyInfoWindow.prototype, "longitude", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "isOpen", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AgmSnazzyInfoWindow.prototype, "isOpenChange", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "placement", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "maxWidth", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "maxHeight", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "backgroundColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "padding", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "border", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "borderRadius", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "fontColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "fontSize", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "pointer", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "shadow", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "openOnMarkerClick", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "closeOnMapClick", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AgmSnazzyInfoWindow.prototype, "wrapperClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "closeWhenOthersOpen", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "showCloseButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AgmSnazzyInfoWindow.prototype, "panOnOpen", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AgmSnazzyInfoWindow.prototype, "beforeOpen", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AgmSnazzyInfoWindow.prototype, "afterClose", void 0);
__decorate([
    ViewChild('outerWrapper', { read: ElementRef, static: false }),
    __metadata("design:type", ElementRef)
], AgmSnazzyInfoWindow.prototype, "_outerWrapper", void 0);
__decorate([
    ViewChild('viewContainer', { read: ViewContainerRef, static: false }),
    __metadata("design:type", ViewContainerRef)
], AgmSnazzyInfoWindow.prototype, "_viewContainerRef", void 0);
__decorate([
    ContentChild(TemplateRef, { static: false }),
    __metadata("design:type", TemplateRef)
], AgmSnazzyInfoWindow.prototype, "_templateRef", void 0);
AgmSnazzyInfoWindow = __decorate([ __param(0, Optional()), __param(0, Host()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [AgmMarker,
        GoogleMapsAPIWrapper,
        MarkerManager,
        MapsAPILoader])
], AgmSnazzyInfoWindow);

let AgmSnazzyInfoWindowModule = class AgmSnazzyInfoWindowModule {
};
/** @nocollapse */
AgmSnazzyInfoWindowModule.ɵfac = function AgmSnazzyInfoWindowModule_Factory(t) { return new (t || AgmSnazzyInfoWindowModule)(); };
/** @nocollapse */
AgmSnazzyInfoWindowModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AgmSnazzyInfoWindowModule });
/** @nocollapse */
AgmSnazzyInfoWindowModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AgmSnazzyInfoWindow, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'agm-snazzy-info-window',
                template: '<div #outerWrapper><div #viewContainer></div></div><ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc1.AgmMarker, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc1.GoogleMapsAPIWrapper }, { type: ɵngcc1.MarkerManager }, { type: ɵngcc1.MapsAPILoader }]; }, { isOpen: [{
            type: Input
        }], isOpenChange: [{
            type: Output
        }], placement: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], openOnMarkerClick: [{
            type: Input
        }], closeOnMapClick: [{
            type: Input
        }], closeWhenOthersOpen: [{
            type: Input
        }], showCloseButton: [{
            type: Input
        }], panOnOpen: [{
            type: Input
        }], beforeOpen: [{
            type: Output
        }], afterClose: [{
            type: Output
        }], latitude: [{
            type: Input
        }], longitude: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], padding: [{
            type: Input
        }], border: [{
            type: Input
        }], borderRadius: [{
            type: Input
        }], fontColor: [{
            type: Input
        }], fontSize: [{
            type: Input
        }], pointer: [{
            type: Input
        }], shadow: [{
            type: Input
        }], wrapperClass: [{
            type: Input
        }], _outerWrapper: [{
            type: ViewChild,
            args: ['outerWrapper', { read: ElementRef, static: false }]
        }], _viewContainerRef: [{
            type: ViewChild,
            args: ['viewContainer', { read: ViewContainerRef, static: false }]
        }], _templateRef: [{
            type: ContentChild,
            args: [TemplateRef, { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AgmSnazzyInfoWindowModule, [{
        type: NgModule,
        args: [{
                declarations: [AgmSnazzyInfoWindow],
                exports: [AgmSnazzyInfoWindow]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AgmSnazzyInfoWindowModule, { declarations: [AgmSnazzyInfoWindow], exports: [AgmSnazzyInfoWindow] }); })();

// public API

/**
 * Generated bundle index. Do not edit.
 */

export { AgmSnazzyInfoWindow, AgmSnazzyInfoWindowModule };

